import { Button, Drawer, Grid, Typography } from "@mui/material"
import React from "react"
import { useForm } from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSPhone from "../../../Components/Phone/WSPhone";
import WSSCheckBoxField from "../../../Components/CheckBox/WSCheckBox";
import config from "../../../Config/clientConfig.json";


export const AccountListDrawer:React.FC<any>=React.memo(({open,onClose})=>{
    const {
        register,
        control,
        handleSubmit
    }= useForm();
    return(
<Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '20rem', padding: '1rem', top: '5rem', height: `calc(100% - 5rem)` }, // Adjust width and padding to match your design
      }}
    >
      <Grid container direction="column" spacing={2}>
        {/* Header with Close Button */}
        <Grid item container justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold" color={"green"}>
           Search
          </Typography>
          <WSIcons.CloseIcon onClick={onClose}  />
        </Grid>
        </Grid>
        <Grid item container spacing={2} alignItems="center" sx={{mt:2}}>
         
          <Grid item xs={12}>
          <WSTextField
            label={"Account Name"}
            {...register("accountname")}
            id="accountname"
            name="accountname"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
          </Grid>
          <Grid item xs={12}>
          <WSTextField
            label={"Contact Person"}
            {...register("contactperson")}
            id="contactperson"
            name="contactperson"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
          </Grid>
          <Grid item xs={12}>
          <WSTextField
            label={"City"}
            {...register("city")}
            id="city"
            name="city"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
          </Grid>
          <Grid item xs={12}>
          <WSPhone label={"Phone No"} id={"phone"} name={"phone"} control={control} labelType="Normal" />

          </Grid>
          <Grid item xs={12}>
          <WSSelectField
              rules={{ required: true }}
              {...register("accounttype")}
              id="accounttype"
              control={control}
              defaultValue={"0"}
              label="Account Type"
              name="accounttype"
              labelType="Normal"
              options={config.accounttypeConfig.staticOptionData}
            />
          </Grid>
          <Grid item xs={12}>
          <WSSCheckBoxField
                        id="inactive"
                        {...register('inactive')}
                        label="Inactive"
                        control={control}
                        rules={{ required: false }}
                        defaultValue={false}
                    />
                    </Grid>
          <Grid item container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <Button variant="outlined" sx={{color:"green",borderColor:"green"}}>
<WSIcons.SyncIcon/>
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="success">
              Search
            </Button>
          </Grid>
        </Grid>
        </Grid>
        </Drawer>
    )
})